import type { FieldValuesFromFieldErrors } from "@hookform/error-message";
import type { FieldErrors, FieldName, FieldValues, Path } from "react-hook-form";

export function getFormError<T extends FieldValues>(
	errors: FieldErrors<T>,
	name: FieldName<FieldValuesFromFieldErrors<FieldErrors<T>>> | Path<T> | undefined,
): string | undefined {
	if (!name) return undefined;

	if (Array.isArray(errors[name])) {
		const firstItem = errors[name][0];
		if (firstItem) {
			const firstKey = Object.keys(firstItem)[0];
			const newName = `${name}.0.${firstKey}` as Path<T>;
			return getFormError(errors, newName);
		}
	}

	const segments = name.split(".");
	let current: any = errors;

	for (const segment of segments) {
		if (current == null) return undefined;

		// Detect numeric segments → array index
		if (Array.isArray(current) && /^\d+$/.test(segment)) {
			current = current[Number(segment)];
		} else {
			current = current[segment];
		}
	}

	return typeof current?.message === "string" ? current.message : undefined;
}
